var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.744 36.293C9.374 35.053 8 33.58 8 32c0-4.419 10.747-8 24-8s24 3.581 24 8c0 1.904-2 3.653-5.333 5.03M32 29.36l.027-.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.021 16c-.013-2.728-.701-4.659-2.125-5.386-3.939-2.003-12.008 5.946-18.027 17.754-6.016 11.81-7.704 23.01-3.765 25.016 1.405.717 3.339.163 5.52-1.384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 11.339c-1.76-1.03-3.315-1.325-4.496-.723-3.939 2.006-2.25 13.206 3.768 25.014 6.016 11.813 14.085 19.76 18.021 17.754 3.502-1.784 2.558-10.829-1.92-21.112"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat5);
export default __webpack_public_path__ + "static/media/cat-5.3368d4cde835d6183852a3fa7f24ae21.svg";
export { ForwardRef as ReactComponent };